import Head from 'next/head';
import { getOpenGraphImage } from 'utils/query';

interface Props {
  type?: string;
  title?: string;
  image?: string;
  locale?: string;
  siteName?: string;
  url?: string | null;
  description?: string;
  canonicalUrl?: string;
}

interface MetadataProps {
  metadata: Props;
}

export const CustomMetadata = ({ metadata }: MetadataProps) => {
  const {
    url,
    type,
    title,
    locale,
    siteName,
    description,
    image = getOpenGraphImage({}),
  } = metadata;

  if (!title || title === 'undefined') {
    return null;
  }

  return (
    <Head>
      <title>{metadata.title}</title>
      <meta name="description" content={description} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />

      {url && <meta property="og:url" content={url} />}
      <meta property="og:site_name" content={siteName} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="800" />
      <meta property="og:image:height" content="600" />
      <meta property="og:locale" content={locale} />
      <meta property="og:type" content={type} />

      {metadata?.canonicalUrl && (
        <link rel="canonical" href={metadata?.canonicalUrl} />
      )}
    </Head>
  );
};
